<script setup>
import { ref, onMounted, watch, defineExpose, reactive, defineEmits } from "vue"
import i18n from "@/i18n"
import { dateFormat1 } from "@/utils/common.js";
import { useRouter, useRoute } from "vue-router";
import usetablePageNation from "@/utils/hooks/usetablePageNation" //分页hooks
import useMessage from "@/utils/hooks/useMessage" //信息hooks
import Swal from "sweetalert2";
import { getBusinessInfoList, deleteBusinessInfo, putBusinessInfoStatus, company_type_list } from "@/service"
import countryListData from '@/utils/country.js';
import { getLangValue, switch_company_type_list_to_language_config } from "@/utils/common"; //获取后端语言
const emits = defineEmits(['updateTabData', 'viewTabData'])
// const mockData = [
//     {
//         id: '31313',
//         status: '0', //未审批
//         "company_name": "金科组数未审批",
//         "company_type": "生产商",
//         "contact_first_name": "feng",
//         "contact_last_name": "tao",
//         "contact_email": "11107949255@qq.com",
//         "landline_number": "2659866",
//         "mobile_phone_number": "15108343658",
//         "third_party_certification_company": true,
//         "business_scope": "服装数据库,纱线数据库",
//         "place_of_incorporation": "dwq ",
//         "certificate_number": "dwq131",
//         "company_qualification": [
//             "66988197b9fc9a463208f059"
//         ],
//         "Enterprise_registered_country": "阿富汗",
//         "phoneCountry": "阿富汗",
//         "phone_numberCountry": "安哥拉",
//         "company_address": [
//             {
//                 "name": "AF",
//                 "country": "阿富汗",
//                 "province": "11",
//                 "city": "11",
//                 "address1": "1",
//                 "address2": "",
//                 "address3": "",
//                 "postcode": "1"
//             },
//             {
//                 "name": "AF",
//                 "country": "阿富汗",
//                 "province": "1",
//                 "city": "11",
//                 "address1": "1",
//                 "address2": "",
//                 "address3": "",
//                 "postcode": "1"
//             }
//         ]
//     },
//     {
//         id: '31313',
//         status: '1', //已审批
//         "company_name": "金科组数已审批",
//         "company_type": "生产商",
//         "contact_first_name": "feng",
//         "contact_last_name": "tao",
//         "contact_email": "11107949255@qq.com",
//         "landline_number": "2659866",
//         "mobile_phone_number": "15108343658",
//         "third_party_certification_company": true,
//         "business_scope": "服装数据库,纱线数据库",
//         "place_of_incorporation": "dwq ",
//         "certificate_number": "dwq131",
//         "company_qualification": [
//             "66988197b9fc9a463208f059"
//         ],
//         "Enterprise_registered_country": "阿富汗",
//         "phoneCountry": "阿富汗",
//         "phone_numberCountry": "安哥拉",
//         "company_address": [
//             {
//                 "name": "AF",
//                 "country": "阿富汗",
//                 "province": "11",
//                 "city": "11",
//                 "address1": "1",
//                 "address2": "",
//                 "address3": "",
//                 "postcode": "1"
//             },
//             {
//                 "name": "AF",
//                 "country": "阿富汗",
//                 "province": "1",
//                 "city": "11",
//                 "address1": "1",
//                 "address2": "",
//                 "address3": "",
//                 "postcode": "1"
//             }
//         ]
//     },
//     {
//         id: '31313',
//         status: '2', //未通过
//         "company_name": "金科组数未通过",
//         "company_type": "生产商",
//         "contact_first_name": "feng",
//         "contact_last_name": "tao",
//         "contact_email": "11107949255@qq.com",
//         "landline_number": "2659866",
//         "mobile_phone_number": "15108343658",
//         "third_party_certification_company": true,
//         "business_scope": "服装数据库,纱线数据库",
//         "place_of_incorporation": "dwq ",
//         "certificate_number": "dwq131",
//         "company_qualification": [
//             "66988197b9fc9a463208f059"
//         ],
//         "Enterprise_registered_country": "阿富汗",
//         "phoneCountry": "阿富汗",
//         "phone_numberCountry": "安哥拉",
//         "company_address": [
//             {
//                 "name": "AF",
//                 "country": "阿富汗",
//                 "province": "11",
//                 "city": "11",
//                 "address1": "1",
//                 "address2": "",
//                 "address3": "",
//                 "postcode": "1"
//             },
//             {
//                 "name": "AF",
//                 "country": "阿富汗",
//                 "province": "1",
//                 "city": "11",
//                 "address1": "1",
//                 "address2": "",
//                 "address3": "",
//                 "postcode": "1"
//             }
//         ]
//     }
// ]
const tableInfo = ref([])
const router = useRouter()
const route = useRoute()
const loading = ref(false)
const table_head = ref([
    { label: getLangValue('my.account', "form_companyName"), width: '10%', },
    { label: getLangValue('my.account', "form_Enterprisetype"), width: '10%', key: 'company_type' },
    { label: getLangValue('my.account', "form_contacts"), width: '10%', },
    { label: getLangValue('my.account', "form_email"), width: '10%', },
    { label: getLangValue('my.account', "form_phone_number"), width: '10%', },
    { label: getLangValue('business-user', "newUser"), width: '10%', },
    { label: getLangValue('my.account', "form_Enterprise_registered_address"), width: '10%', },
    { label: getLangValue('business-user', "registre_time"), width: '10%', sortable: true },
    { label: getLangValue("base.operation"), width: '10%', },
])
const pageSizeOption = [10, 20, 30, 40, 50]
const companyTypeList = ref([])
const { total, currentPage, pageSize, pageOption } = usetablePageNation()
const { alertInfo, openAlert, formValidataAlert } = useMessage()

const searchInfo = reactive({
    type: route.query.search_type || 0, //类型
    keyword: '',
    date: null,
    company_type: '',
    company_register_address: '',
    order_by: 'desc'
})
const handler = (type, info) => {
    //按钮处理
    let url;
    switch (type) {
        case 'view':
            // 根据状态显示信息   未审批直接到审批页面    未通过  已通过到详情页面
            if (searchInfo.type == 0) {
                url = router.resolve({ path: '/business_information_management_examine', query: { id: info.id, } }).href
            } else {
                url = router.resolve({ path: '/business_information_management_detail', query: { id: info.id, search_type: searchInfo.type } }).href
            }
            window.open(url, '_blank')
            break;
        case 'edit':
            url = router.resolve({ path: '/business_information_management_detail', query: { type: 'edit', id: info.id, search_type: searchInfo.type } }).href
            window.open(url, '_blank')
            break;
        case 'delete':
            deleteData(info)
            break;
    }
}

const getCountryBykey = (countryKey) => {
    if (countryKey) {
        let arr = countryListData.filter(item => item.key === countryKey)
        if (arr.length > 0) {
            return  i18n.global.locale == 'en' ?  arr[0].en : arr[0].zh
        }
    }
    return ''
}
const deleteData = async (info) => {
    const { id, company_name } = info;
    Swal.fire({
        title: getLangValue("base.delete_alert_title") + `${i18n.global.locale == 'ch' ? company_name + '?' : ''}`,
        text: getLangValue("base.delete_alert_info"),
        icon: "warning",
        showCancelButton: true,
        cancelButtonColor: "#f46a6a",
        confirmButtonColor: "#34c38f",
        confirmButtonText: getLangValue("base.done"),
        cancelButtonText: getLangValue("base.cancel"),
    }).then(async (result) => {
        if (result.isConfirmed) {
            // console.log(id)
            //延迟2s操作
            let resp = await deleteBusinessInfo(id);
            if (resp) {
                openAlert({
                    variant: resp.code == 1 ? "danger" : 'success',
                    content: resp.code == 1 ? resp.message : getLangValue("base.delete_success"),
                });
                //  更新
                getDataList();
            }
        }
    });
}

const getDataList = async () => {
    // let arr = searchInfo.date == null || !searchInfo.date ? [] : searchInfo.date.replaceAll(' ', '').split('to')
    // console.log(arr);
    //获取数据
    let params = {
        page: currentPage.value - 1,
        limit: pageSize.value,
        keyword: searchInfo.keyword,
        status: searchInfo.type, //类型
        register_date: searchInfo.date == null  || !searchInfo.date ? "" : JSON.stringify(searchInfo.date),
        company_type: searchInfo.company_type,
        place_of_incorporation: searchInfo.company_register_address,
        order_by: searchInfo.order_by,
        sort_field: 'create_time',
    }
    // tableInfo.value = mockData.filter(item => item.status == params.type)
    let xx = true
    if (xx) {
        loading.value = true
        const resp = await getBusinessInfoList(params);
        loading.value = false
        if (resp.code == 0) {
            tableInfo.value = resp.payload.data;
            tableInfo.value.forEach(item => {
                item.disabled = !item.disabled
            })
            // 需要根据筛选项公开类型选择使用哪个数据
            // 不公开 1
            // 仅对供应链公开 3 
            // 完全公开 2
            if (searchInfo.type == 0) {
                total.value = resp.payload.wait_review_total
            } else if (searchInfo.type == 1) {
                total.value = resp.payload.review_failed_total
            } else {
                total.value = resp.payload.review_success_total
            }
            emits('updateTabData', resp.payload)
        } else {
            openAlert({
                variant: "danger",
                content: resp.message,
            });
        }
    }
}

const switchChange = async ({ id, disabled }) => {
    //切换开关
    let params = {
        disabled: disabled ? 0 : 1
    }
    if (params.disabled == 1) {
        // 关闭用户
        Swal.fire({
            title: getLangValue('business-user', "disableAccount"),
            text: getLangValue('business-user', "disableAccountResult"),
            icon: "warning",
            showCancelButton: true,
            cancelButtonColor: "#f46a6a",
            confirmButtonColor: "#34c38f",
            confirmButtonText: getLangValue("base.done"),
            cancelButtonText: getLangValue("base.cancel"),
        }).then(async (result) => {
            if (result.isConfirmed) {
                // console.log(id)
                //延迟2s操作
                let resp = await putBusinessInfoStatus(id, params);
                if (resp) {
                    openAlert({
                        variant: resp.code == 1 ? "danger" : 'success',
                        content: resp.code == 1 ? resp.message : getLangValue("base.edit_success"),
                    });
                    //  更新
                    getDataList();
                }
            } else {
                getDataList();
            }
        });
    } else {
        const resp = await putBusinessInfoStatus(id, params)
        if (resp) {
            openAlert({
                variant: resp.code == 1 ? "danger" : 'success',
                content: resp.code == 1 ? resp.message : getLangValue("base.edit_success"),
            });
            //  更新
            getDataList();
        }
    }



}

const sort = () => {
    let dom = document.querySelector('.sortable')
    console.log(dom.classList);
    let classList = dom.classList
    if (classList.value.includes('desc')) {
        // 现在是倒叙 变为升序
        classList.remove('desc')
        classList.add('asc')
        searchInfo.order_by = 'asc'
    } else {
        // 现在是升序 变为降序
        classList.remove('asc')
        classList.add('desc')
        searchInfo.order_by = 'desc'
    }
}
const getCompany_type_list = async () => {
    const reps = await company_type_list()
    if (reps.code == 0) {
        companyTypeList.value =  switch_company_type_list_to_language_config(reps.payload)
        getDataList()
    }
}

const getCompanyTypeName = (str) => {
    // 根据企业类型id获取名字
    let arr = str ? str.split(',') : []
    let name = []
    for (const item in arr) {
        let arr1 = companyTypeList.value.filter(item1 => item1.id == arr[item])
        if (arr1.length) {
            name.push(arr1[0].name)
        }
    }
    return name.join(',')
}

watch(pageSize, () => {
    currentPage.value = 1;
    getDataList()
})


watch(currentPage, () => {
    getDataList();
})

watch(searchInfo, () => {
    currentPage.value = 1;
    getDataList();
    if (searchInfo.type == 0) {
        table_head.value = [
            { label: getLangValue('my.account', "form_companyName"), width: '10%', },
            { label: getLangValue('my.account', "form_Enterprisetype"), width: '10%', key: 'company_type' },
            { label: getLangValue('my.account', "form_contacts"), width: '10%', },
            { label: getLangValue('my.account', "form_email"), width: '10%', },
            { label: getLangValue('my.account', "form_phone_number"), width: '10%', },
            { label: getLangValue('business-user', "newUser"), width: '10%', },
            { label: getLangValue('my.account', "form_Enterprise_registered_address"), width: '10%', },
            { label: getLangValue('business-user', "registre_time"), width: '10%', sortable: true },
            { label: getLangValue("base.operation"), width: '10%', },
        ]
    } else if (searchInfo.type == 1) {
        table_head.value = [
            { label: getLangValue('my.account', "form_companyName"), width: '10%', },
            { label: getLangValue('my.account', "form_Enterprisetype"), width: '10%', key: 'company_type' },
            { label: getLangValue('my.account', "form_contacts"), width: '10%', },
            { label: getLangValue('my.account', "form_email"), width: '10%', },
            { label: getLangValue('my.account', "form_phone_number"), width: '10%', },
            // { label: getLangValue('business-user', "newUser"), width: '10%', },
            { label: getLangValue('my.account', "form_Enterprise_registered_address"), width: '10%', },
            { label: getLangValue('business-user', "registre_time"), width: '10%', sortable: true },
            { label: getLangValue("base.operation"), width: '10%', },
        ]
    } else {
        table_head.value = [
            { label: getLangValue('my.account', "form_companyName"), width: '10%', },
            { label: getLangValue('my.account', "form_Enterprisetype"), width: '10%', key: 'company_type' },
            { label: getLangValue('my.account', "form_contacts"), width: '10%', },
            { label: getLangValue('my.account', "form_email"), width: '10%', },
            { label: getLangValue('my.account', "form_phone_number"), width: '10%', },
            { label: getLangValue('my.account', "form_Enterprise_registered_address"), width: '10%', },
            { label: getLangValue('business-user', "registre_time"), width: '10%', sortable: true },
            { label: getLangValue('business-user', "lastLoginTime"), width: '10%', },
            { label: getLangValue("base.operation"), width: '10%', },
        ]
    }

}, { deep: true, immediate: true })


onMounted(() => {
    getCompany_type_list();
})
//弹出
defineExpose({
    searchInfo,
    getDataList,
})
</script>

<template>
    <div class="form px-0" v-if="tableInfo.length || loading" style="height: calc(100% - 170px);">
        <!-- Bordered Tables -->
        <div class="my-scroll-bar" style="height:calc(100% - 50px); overflow-y: auto;">
            <table class="table table-bordered table-nowrap mb-0 " v-loading="loading" >
                <thead class="table-light ">
                    <tr>
                        <th scope="col" v-for="(head, index) in table_head" :key="index" style="color: #9599AD;"
                            :width="head.width">
                            <div class="d-flex align-items-center" style="height: 36px;">
                                {{ head.label }}
                                <div class="sortable mx-2 cursor-pointer desc" v-if="head.sortable"
                                    style="position: relative; width: 14px; height: 10px;" @click="sort"></div>
                            </div>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(info, index) in tableInfo" :key="index" style="vertical-align: middle">
                        <td style="max-width: 250px; word-wrap: break-word;word-break: normal; white-space: normal;">{{
                            info.company_name }}</td>
                        <td style="max-width: 400px; word-wrap: break-word;word-break: normal; white-space: normal;">{{
                            getCompanyTypeName(info.company_type) ? getCompanyTypeName(info.company_type) :
                                info.company_type }}</td>
                        <td>{{ i18n.global.locale =='ch'? info.contact_first_name +' '+ info.contact_last_name : info.contact_last_name +' '+ info.contact_first_name }}</td>
                        <td>{{ info.contact_email }}</td>
                        <td>{{ info.mobile_phone_number }}</td>
                        <template v-if="searchInfo.type == 0">
                            <td>{{ info.status == 3 ? $t('hscode.type.no') : $t('hscode.type.yes') }}</td>
                            <td>{{ info.place_of_incorporation ?
                                `${getCountryBykey(info.place_of_incorporation)}(${info.place_of_incorporation})` : ''
                                }}
                            </td>
                            <td>{{ info.create_time ? dateFormat1(info.create_time, 'YYYY-MM-DD') : '' }}</td>
                        </template>
                        <template v-else-if="searchInfo.type == 1">
                            <td>{{ info.place_of_incorporation ?
                                `${getCountryBykey(info.place_of_incorporation)}(${info.place_of_incorporation})` : ''
                                }}
                            </td>
                            <td>{{ info.create_time ? dateFormat1(info.create_time, 'YYYY-MM-DD') : '' }}</td>
                        </template>
                        <template v-else>
                             <td>{{ info.place_of_incorporation ?
                                `${getCountryBykey(info.place_of_incorporation)}(${info.place_of_incorporation})` : ''
                                }}
                            </td>
                            <td>{{ info.create_time ? dateFormat1(info.create_time, 'YYYY-MM-DD') : '' }}</td>
                            <td>{{ info.last_time ? dateFormat1(info.last_time) : '' }}</td>
                        </template>
                        <td>
                            <ul class=" list-inline hstack gap-2 mb-0 ">
                                <li   v-if="searchInfo.type == 2" >
                                    <b-form-checkbox v-model="info.disabled" switch  v-permit="'business-user.on-off'"
                                        @change="switchChange(info)"></b-form-checkbox>
                                </li>
                                <li class="list-inline-item cursor ms-2" v-permit="'business-user.show'">
                                    <div class="text-primary d-inline-block" @click="handler('view', info)">
                                        <i class="fs-16 ri-eye-fill"></i>
                                    </div>
                                </li>
                                <li v-if="searchInfo.type == 2" class="list-inline-item cursor">
                                    <div class="text-primary d-inline-block" @click="handler('edit', info)"
                                        v-permit="'business-user.modify'">
                                        <i class="fs-16 ri-pencil-fill"></i>
                                    </div>
                                </li>
                                <!-- 删除 -->
                                <li class="list-inline-item" title="delete" style="visibility: hidden;">
                                    <div class="d-inline-block text-danger cursor" >
                                        <i class="fs-16 ri-delete-bin-5-fill"></i>
                                    </div>
                                </li>
                            </ul>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <!-- 分页 -->
        <Pagination v-if="total" v-model:page="currentPage" v-model:perPage="pageSize" :pages="pageOption"
            :prePageOption="pageSizeOption" :tab_info_length="total" class="me-5" style="margin-top: 0 !important;">
        </Pagination>
    </div>
    <div v-else style="height: calc(100% - 170px);" class="d-flex align-items-center justify-content-center" >
    <Empty style="margin-top: 200px;"></Empty>
    </div>
    <message-alert :alertInfo="alertInfo" v-if="formValidataAlert"></message-alert>
</template>
<style scoped lang="scss">
.table-bordered> :not(caption)>*>* {
    border: unset;
}
.table-bordered td, .table-bordered th {
    padding: 0.25rem 0.6rem !important;
}

.sortActive {
    color: black;
}

.sortable {
    &::after {
        content: "\f035d";
        position: absolute;
        right: .5rem;
        top: 0px;
        font-size: .8rem;
        font-family: "Material Design Icons";
    }

    &::before {
        content: "\f0360";
        position: absolute;
        right: .5rem;
        top: -8px;
        font-size: .8rem;
        font-family: "Material Design Icons";
    }
}

.desc {
    &::after {
        color: black;
    }
}

.asc {
    &::before {
        color: black;
    }
}
</style>